import { getToken } from './api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;

// Multipart upload with progress. Resolves the JSON response.
export function xhrUpload(path, file, onProgress, { auth = false } = {}) {
  if (file.size > MAX_UPLOAD_BYTES) return Promise.reject(new Error('File is too large (max 25 MB).'));
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const body = new FormData();
    body.append('file', file);
    xhr.open('POST', `${BACKEND_URL}${path}`);
    if (auth) xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText); } catch { /* non-JSON error page */ }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(typeof data.detail === 'string' ? data.detail : `Upload failed (${xhr.status})`));
    };
    xhr.onerror = () => reject(new Error('Network error — check your connection and try again.'));
    xhr.send(body);
  });
}

// Admin image upload (resized + converted to WebP server-side). Resolves {url, width, height}.
export function uploadImage(file, onProgress) {
  if (!file.type.startsWith('image/')) return Promise.reject(new Error('Please choose an image file.'));
  return xhrUpload('/api/admin/uploads/cover', file, onProgress, { auth: true });
}
